import { useCallback } from 'react';
import { useMemo } from 'react';

export type Props<T, U> = {
  value?: T;
  onChange?: (value: T | U) => void;
  setValue?: (value: T) => U;
  getValue?: (value?: T | U) => T;
};

export const useTransformValue = <T, U>({
  value,
  onChange,
  setValue,
  getValue,
}: Props<T, U>) => {
  const transformedValue = useMemo(() => {
    return getValue ? getValue(value) : value;
  }, [getValue, value]);
  const transformedOnChange = useCallback(
    (nextValue: T) => {
      const nextTransformedValue = setValue ? setValue(nextValue) : nextValue;
      onChange?.(nextTransformedValue);
    },
    [onChange, setValue],
  );
  return { value: transformedValue, onChange: transformedOnChange };
};
